import useConceptRaceGameLoop from './useConceptRaceGameLoop.hook';
import { StyledConceptRaceGameLoop } from './ConceptRaceGameloop.styled';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
import { useContext } from 'react';
import RaceConceptAnimation from './RaceConceptAnimation/RaceConceptAnimation';
import ConceptOptions from './ConceptOptions/ConceptOptions';
import AnswerFeedback from './AnswerFeedback/AnswerFeedback';
import ConceptWriteAnswer from './ConceptWriteAnswer/ConceptWriteAnswer';

export default function ConceptRaceGameLoop({ onAnswer, onFinish, mode }) {
  const game = useContext(GameLoopContext);
  useConceptRaceGameLoop({
    onAnswer,
    onFinish,
    game,
    mode,
  });
  return (
    <StyledConceptRaceGameLoop>
      {game.state.currentConcept && game.state.gameConf?.animations && (
        <>
          <RaceConceptAnimation
            concept={game.state.currentConcept}
            isLastCorrect={
              game.state.lastCorrectId == game.state.currentConcept.id
            }
          />
          {mode == 'writing' ? (
            <ConceptWriteAnswer concept={game.state.currentConcept} />
          ) : (
            <ConceptOptions concept={game.state.currentConcept} />
          )}
          {game.state.givingFeedback && <AnswerFeedback />}
        </>
      )}
    </StyledConceptRaceGameLoop>
  );
}
